import { WizDatasource, WizTranslationData } from '@wizeoo/akm-component-lib';
import { IWizTranslationEntry } from '@wizeoo/akm-core-lib';
import { LocaleEngine as BaseLocaleEngine, IVo } from '@wizeoo/akm-compute-lib';
import { TranslatedKeyPair } from '@wizeoo/akm-message-lib';
import { Model } from '../../model/model';
import { TranslatableLabelEntryVO } from '../../vo/common/translation/translatable-label-entry.vo';
import { TranslatableLabelVO } from '../../vo/common/translation/translatable-label.vo';
import { BusinessUnitVO } from '../../vo/core/business-unit.vo';
import { LanguageVO } from '../../vo/locale/language.vo';
import { ViewData } from '../../model/view.data';
import { CtxtEntry } from '../context/user-context.service';


/** gestion de la locale / des traductions */
export class LocaleEngine extends BaseLocaleEngine {
  
  constructor(pmodel: Model) {
    // console.log('construction locale common');
    super(pmodel);
  }

  public get model(): Model {
    return this._model as Model;
  }

  /** alimentation des langues user et Bu sur Init */
  public feedLanguages(): void {
    const bu: BusinessUnitVO = this.model.businessUnitEngine.currentBU;
    this.model.buLocaleCode = bu?.defaultLanguagesVO?.code || ViewData.defaultLocaleCode;

    let userLang: LanguageVO = bu?.defaultLanguagesVO;
    const appContext: CtxtEntry = this.model.userContextService.getVisionContext(); // recherche d'une entrée de contexte utilisateur
    if (appContext?.data?.language) {
      const lm: Map<string, LanguageVO> = new Map(
        this.getLanguageListForBU().map((item) => [item.code, item])
      );
      userLang = lm.get(appContext.data.language);
    }
    // console.log('lm feedLanguage', userLang ? userLang.code : ViewData.defaultLocaleCode);
    this.model.currentLocaleCode = userLang ? userLang.code : ViewData.defaultLocaleCode;
  }

  /**
   * Recherche des langues pour une BU donnée
   */
  public getLanguageListForBU(): LanguageVO[] {
    
    const bu: BusinessUnitVO = this.model.businessUnitEngine.currentBU;
    let languageList: LanguageVO[] = bu?.languagesVO || [];

    // si la bu n'a aucune langue ou que le domaine est wildcardDomain
    if (languageList.length === 0) {
      if(!!bu) {
        // on ajoute la langue par défaut de la BU...
        languageList.push(bu.defaultLanguagesVO);
      } else {
        languageList.push(this.model.languageMap.get(ViewData.defaultLocaleCode));
      }

    }
    const result: LanguageVO[] = [];
    if (languageList && languageList.length > 0) {
      languageList.forEach((vo) => {
        if (!vo.deleted && !vo.deprecated) {
          result.push(vo);
        }
      });
    }
    return result;
  }

  /**
   * Retourne la langue de la liste par son code.
   * @param code : BusinessUnitVO.businessUnitCode cherché
   * @return LanguageVO la langue récupéré en base ou null si elle n'existe pas
   */
  public getLanguageByCode(code: string): LanguageVO {
    let result: LanguageVO = null;
    if (code && this.model.languageList) {
      const tmpColl = this.model.languageList.filter((item: LanguageVO) => item.code === code);
      if (tmpColl.length === 1) {
        result = tmpColl[0];
      }
    }
    return result;
  }

  /**
   * construction d'un TrsLabel correctement alimenté
   * @param trslblVO l'objet traductible source
   */
  public buildTranslationData(trslblVO: TranslatableLabelVO): WizTranslationData {
    const translationData: WizTranslationData = new WizTranslationData();

    // les entries nécessaires pour le composant
    const compoVO: TranslatableLabelEntryVO[] = Array.from(trslblVO.entriesVOMap.values());
    /** construction de la pile de vo complète */
    const languageList: LanguageVO[] = this.getLanguageListForBU();
    languageList.forEach((language: LanguageVO) => {
      if (!trslblVO.entriesVOMap.has(language.code)) { // pour chaque langue (non deprecated) de la BU (langue non deprecated) non présente
        if (!language.deprecated) {
          const labelEntry: TranslatedKeyPair = new TranslatedKeyPair();
          labelEntry.cod = language.code;
          compoVO.push(new TranslatableLabelEntryVO(labelEntry));
        }
      }
    });

    translationData.entryDS = new WizDatasource<IWizTranslationEntry>(compoVO);
    translationData.mainLanguageCode = this.getLocale();
    translationData.defaultLanguageCode = this.getBuLocale();
    return translationData;
  }

  /**
   * création d'une nouvelle instance de translatableVO
   *
   * @param source l'objet (IVO) cible
   * @param field le champ
   * @returns le TrsLabelVO. Le TrsLabel est alimenté sur l'objet
   */
  public newTranslatableVO(source: IVo, field: string): TranslatableLabelVO {
    if (!source[field]) {
      // Si le label n'existe pas : création
      source[field] = new TranslatableLabelVO();
      source[field].entries = {};
    }
    return new TranslatableLabelVO(source[field]);
  }

}
